import { render, staticRenderFns } from "./AutoSuspend.vue?vue&type=template&id=4c9790cd&scoped=true&"
import script from "./AutoSuspend.vue?vue&type=script&lang=js&"
export * from "./AutoSuspend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9790cd",
  null
  
)

export default component.exports